
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Music2 } from 'lucide-react';
import { UserProfile } from '@/types';

interface AccountStatsProps {
  userProfile?: UserProfile;
}

const AccountStats: React.FC<AccountStatsProps> = ({ userProfile }) => {
  // Use default values that match the profile if no userProfile is provided
  const totalReleases = userProfile?.totalReleases || 12;
  const totalStreams = userProfile?.totalStreams || 32478;
  const followers = userProfile?.followers || 842;
  const following = userProfile?.following || 56;
  const memberSince = userProfile?.memberSince 
    ? userProfile.memberSince.toLocaleDateString('en-US', { month: 'long', year: 'numeric' })
    : 'March 2023';

  return (
    <Card className="neo-card">
      <CardHeader className="pb-2">
        <CardTitle className="text-base flex items-center gap-2">
          <Music2 className="h-4 w-4 text-muted-foreground" />
          Account Stats
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        <div>
          <p className="text-sm text-muted-foreground">Total Releases</p>
          <p className="font-medium">{totalReleases} tracks</p>
        </div>
        <div>
          <p className="text-sm text-muted-foreground">Total Streams</p>
          <p className="font-medium">{totalStreams.toLocaleString()}</p>
        </div>
        <div>
          <p className="text-sm text-muted-foreground">Following</p>
          <p className="font-medium">{following} musicians</p>
        </div>
        <div>
          <p className="text-sm text-muted-foreground">Followers</p>
          <p className="font-medium">{followers.toLocaleString()} followers</p>
        </div>
        <div>
          <p className="text-sm text-muted-foreground">Member Since</p>
          <p className="font-medium">{memberSince}</p>
        </div>
      </CardContent>
    </Card>
  );
};

export default AccountStats;
